export const TOUJOU_EVENT_CONTACT_DIALOG_OPEN = 'toujou-event-contact-dialog-open';
